import React, {createRef, useState} from "react";
import DataGrid, {
    Column,
    Pager,
    Paging,
    Export,
    SearchPanel,
    Sorting,
} from "devextreme-react/data-grid";
import ExcelJS from "exceljs";
import {exportDataGrid} from "devextreme/excel_exporter";
import format from "date-fns/format";
import autoTable from 'jspdf-autotable'
import saveAs from 'file-saver';
import {FormContainer} from "../../../../palette/Palette";
import {jsPDF} from "jspdf";
import {exportDataGrid as exportDataGridToPdf} from "devextreme/pdf_exporter";
import {years} from "../../../../utils/Utils";
import VerticalSpace from "../../../../palette/VerticalSpace";
import HeaderPage from "../../../../palette/HeaderPage";
import SendPromotions from "./SendPromotions";
import {Popup} from "devextreme-react/popup";

const actualDataYear = format(new Date(), 'yyyy')

function PromotionsGrid(props) {

    const {
        dataSource, setVisibleForm, setVisibleGrid, setDataEdit, setEdit, DataStore, setTrigger, trigger, load
    } = props

    const {companyName, idCompany, contactNumbers, imageAsUrl, dataEdit}=DataStore

    const [popupVisible, setPopupVisible] = React.useState(false);
    const [actualYear, setActualYear] = useState(actualDataYear);
    const [dataSend, setDataSend] = useState(null);

    const dataGridRef = React.createRef();

    const onExporting = (e) => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Main sheet');

        exportDataGrid({
            component: e.component,
            worksheet: worksheet,
            autoFilterEnabled: true,
        }).then(function () {

            const headerCompany = worksheet.getRow(2);
            const headerReport = worksheet.getRow(3);
            const headerDate = worksheet.getRow(4);

            headerCompany.getCell(2).value = companyName;
            headerCompany.getCell(2).font = {bold: true, size: 16, underline: 'double'};

            headerReport.getCell(2).value = `Reporte : Gestión de j`;
            headerReport.getCell(2).font = {name: 'Segoe UI Light', size: 12, bold: 600};
            headerReport.getCell(2).alignment = {horizontal: 'left'};

            headerDate.getCell(2).value = `Fecha : ${format(new Date(), 'yyyy-MM-dd')}`;
            headerDate.getCell(2).font = {name: 'Segoe UI Light', size: 8, bold: 700};
            headerDate.getCell(2).alignment = {horizontal: 'left'};

            workbook.xlsx.writeBuffer().then(function (buffer) {
                saveAs(new Blob([buffer], {type: 'application/octet-stream'}), 'promociónes.xlsx');
            });
        });
        e.cancel = true;
    };

    function exportGridPDF() {
        const pdfDoc = new jsPDF();
        const dataGrid = dataGridRef.current.instance;

        const options = {
            jsPDFDocument: pdfDoc,
            component: dataGrid,
            autoTableOptions: {
                margin: {top: 35, left: 15}
            }
        };

        exportDataGridToPdf(options).then(() => {
            pdfDoc.setFontSize(12);
            const pageCount = pdfDoc.internal.getNumberOfPages();
            for (let i = 1; i <= pageCount; i++) {
                pdfDoc.setPage(i);
                const pageSize = pdfDoc.internal.pageSize;
                const pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();
                const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
                const header = companyName;
                const report = `Reporte : Rutas conductores`
                const date = `Fecha : ${format(new Date(), 'yyyy-MM-dd')}`
                const footer = `Pagina ${i} de ${pageCount}`;

                // Header
                pdfDoc.setFontSize(16)
                pdfDoc.setFont('helvetica', '', 'bold')
                pdfDoc.text(header, 15, 10, {baseline: 'top'});
                pdfDoc.setFontSize(12)
                pdfDoc.setFont('helvetica', '', 500)
                pdfDoc.text(report, 15, 17, {baseline: 'top'});
                pdfDoc.setFontSize(8)
                pdfDoc.setFont('helvetica', '', 500)
                pdfDoc.text(date, 15, 22, {baseline: 'top'});

                // Footer
                pdfDoc.setFontSize(8)
                pdfDoc.text(footer, pageWidth / 2 - (pdfDoc.getTextWidth(footer) / 2), pageHeight - 15, {baseline: 'bottom'});

            }
        }).then(() => {
            pdfDoc.save('promociónes.pdf');
        });
    }

    const onToolbarPreparing = (e) => {

        const {items} = e.toolbarOptions

        items.unshift({
            location: 'after',
            widget: 'dxButton',
            options: {
                width: 120,
                text: 'Imprimir',
                elementAttr: {id: 'btn-pdf'},
                icon: 'far fa-file-pdf',
                onClick: exportGridPDF
            }
        },)

        items.unshift({
            location: 'before',
            widget: 'dxSelectBox',
            options: {
                width: 150,
                placeholder: 'Selecionar...',
                items: years,
                showClearButton: true,
                value: actualYear,
                onValueChanged: (e) => {
                    setActualYear(e.value)
                    setTrigger(!trigger)
                }
            }
        },)

        items.unshift({
            location: 'before',
            widget: 'dxButton',
            options: {
                text: 'Crear promoción',
                icon: 'fas fa-plus-circle',
                elementAttr: {id: 'button-add-grid'},
                onClick: () => {
                    setVisibleForm(true)
                    setEdit(false)
                    setVisibleGrid(false)
                }
            }
        })
    }

    const onRowUpdating = (e) => {
        const state = e.row.data.state;
        setDataEdit(e.row.data);
        if (state === 'Registrado') {
            setVisibleForm(false)
            setEdit(true)
            setVisibleGrid(false)
        }
    };

    const onSendPromotion = (e) => {
        const state = e.row.data.state;
        setDataSend(e.row.data);
        if (state === 'Registrado') {
            setPopupVisible(true);
        }
    };

    const buttons = [
        {
            hint: 'Editar',
            icon: 'fas fa-pencil-alt',
            visible: true,
            onClick: onRowUpdating,
        },
        {
            hint: 'Enviar promoción',
            icon: 'fas fa-tags',
            visible: true,
            onClick: onSendPromotion,
        },
    ];

    return (
        <>
            <VerticalSpace space={30}/>
            <Popup
                visible={popupVisible}
                onHiding={() => setPopupVisible(false)}
                dragEnabled={false}
                closeOnOutsideClick={false}
                showCloseButton={false}
                showTitle={true}
                title={`Enviar promoción`}
                width={330}
                height={'auto'}
            >

                <SendPromotions companyName={companyName} idCompany={idCompany} dataSource={dataSend}
                                setPopupVisible={setPopupVisible} contactNumbers={contactNumbers}
                                logoUrl={imageAsUrl}/>


            </Popup>
            <div className="grid-container">
                <HeaderPage icon={'fab fa-opencart'} text={'Promociónes'} load={load}
                            textLoad={'Cargando...'}/>
                <FormContainer>

                    <DataGrid
                        id="promotions"
                        ref={dataGridRef}
                        dataSource={dataSource}
                        keyExpr="ID"
                        allowColumnReordering={true}
                        showBorders={true}
                        onToolbarPreparing={onToolbarPreparing}
                        rowAlternationEnabled={true}
                        noDataText={'Esperando datos...'}
                        onExporting={onExporting}
                    >
                        <SearchPanel visible={true}
                                     width={240}
                                     placeholder="Buscar"/>
                        <Export enabled={true} texts={{exportAll: 'Excel'}}/>
                        <Sorting mode="multiple"/>
                        <Paging defaultPageSize={15}/>
                        <Pager
                            showPageSizeSelector={true}
                            allowedPageSizes={[5, 10, 20]}
                            showInfo={true}/>
                        <Column dataField="cod" alignment={'center'} caption={'Codigo de promoción'}/>
                        <Column dataField="start" alignment={'center'} caption={'Fecha de inicio'} dataType="date"/>
                        <Column dataField="end" alignment={'center'} caption={'Fecha de expiración'}/>
                        <Column dataField="value" alignment={'center'} caption={'Valor'}
                                format={{type: 'currency', precision: 2}}/>
                        <Column dataField="percentage" alignment={'center'} caption={'Porcentaje'}
                                cellRender={DiffCell}/>
                        <Column dataField="state" alignment={'center'} caption={'Estado'}/>
                        <Column type="buttons" width={100}
                                buttons={buttons}/>
                    </DataGrid>
                </FormContainer>
            </div>
        </>
    )


}

export default PromotionsGrid

function DiffCell(cellData) {
    return (
        <div>
            <span>{`${((cellData.data.percentage / 100) * 10000).toFixed(1)} %`}</span>
        </div>
    );
}
